import React, { useEffect } from "react";
import axios from '../../axios/axiosconf';

function Logout() {
    useEffect(() => {
        let token = null;
        try {
            const raw = localStorage.getItem('userdata');
            if (raw) {
                token = JSON.parse(raw).access_token;
            }
        } catch (error) {
            console.log(error);
        }

        localStorage.clear();

        const config = token
            ? { headers: { Authorization: 'Bearer ' + token } }
            : {};

        axios.get('/logout', config).catch((error) => {
            console.log(error);
        });

        window.location.replace(
            `${window.location.pathname}${window.location.search}#/login`
        );
    }, []);

    return null;
}

export default Logout;
